import { AppThunk } from '../../types';
import { selectSentEvents } from './selectors';
import { setSentEvent } from './slice';

export const fireEventOnce =
  (event: string, callBack: () => void): AppThunk =>
  (dispatch, getState) => {
    const sentEvents = selectSentEvents(getState());
    if (!sentEvents.includes(event)) {
      dispatch(setSentEvent(event));
      callBack();
    }
  };
